import { render, staticRenderFns } from "./specialities-edit.vue?vue&type=template&id=7bf0c64e&scoped=true"
import script from "./specialities-edit.vue?vue&type=script&lang=js"
export * from "./specialities-edit.vue?vue&type=script&lang=js"
import style0 from "./specialities-edit.vue?vue&type=style&index=0&id=7bf0c64e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf0c64e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bf0c64e')) {
      api.createRecord('7bf0c64e', component.options)
    } else {
      api.reload('7bf0c64e', component.options)
    }
    module.hot.accept("./specialities-edit.vue?vue&type=template&id=7bf0c64e&scoped=true", function () {
      api.rerender('7bf0c64e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/supplier/edit-poppers/specialities-edit.vue"
export default component.exports